export const environment = {
    production: false,
    ACCESS_TOKEN_KEY: "token",
    REFRESH_TOKEN_KEY: "refreshToken",
    USER_DETAILS: "user-details",
    API_ENDPOINT: "api-endpoint",
    ORG_KEY: "orgkey",
    MATTER_NO: "matterId",
    ACTIONSTEP_ORG_KEY: "actionStepOrgKey"
};
